import { render } from "./RoomTo.vue?vue&type=template&id=8998dd52"
import script from "./RoomTo.vue?vue&type=script&lang=js"
export * from "./RoomTo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__